// extracted by mini-css-extract-plugin
export default {"meetingSidebarContainer":"Z4pgIh9nnYu0VO4_Cvp9","meetingSidebarContent":"WCk1KxfQ29E2NgxwjoXI"};